export default __webpack_public_path__ + "static/media/rhino-min.5112cffe.jpg";